// extracted by mini-css-extract-plugin
export default {"component":"styles__component--lhMm0","border":"styles__border--Eb1Um"};